import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { t } from 'i18next';
import { glb_sv } from 'src/utils';

const TableLocationDevice = ({ tableRef, data, property }) => {
    return (
        <TableContainer
            sx={{}}
            style={{ display: 'none' }}
        >
            <Table ref={tableRef}>
                <TableHead>
                    <TableRow>
                        <TableCell>{t('code_device')}</TableCell>
                        <TableCell>{t('name_device')}</TableCell>
                        <TableCell>{t('name_supplier')}</TableCell>
                        <TableCell>{t('producer')}</TableCell>
                        <TableCell>{t('quan_ly_bo_phan')}</TableCell>
                        <TableCell>{t('price')}</TableCell>
                        <TableCell>{t('status_device')}</TableCell>
                        <TableCell>{t('checking_after')}</TableCell>
                        <TableCell>{t('can_grinding')}</TableCell>
                        <TableCell>{t('code_cabinet')}</TableCell>
                        <TableCell>{"ID "+ t('drawer')}</TableCell>
                        <TableCell>{t('cell')}</TableCell>
                        <TableCell>{t('quantity_category')}</TableCell>
                        {property?.length > 0 &&
                            property.map((item, index) => (
                                <TableCell key={index} align="right">
                                    {item?.label}
                                </TableCell>
                            ))}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data?.map((ele, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell>{ele?.device_cd}</TableCell>
                                <TableCell>{ele?.device_nm}</TableCell>
                                <TableCell>{ele?.supplier_cd}</TableCell>
                                <TableCell>{ele?.producer?.label}</TableCell>
                                <TableCell>
                                    {ele?.depart_id?.length > 0 &&
                                        ele?.depart_id?.map((item, index) => (
                                            <span key={index} align="right">
                                                {item?.value},
                                            </span>
                                        ))}
                                </TableCell>
                                <TableCell>{ele?.price}</TableCell>
                                <TableCell>{ele?.status_action}</TableCell>
                                <TableCell>
                                    {ele.expiry_date && glb_sv.formatDate(ele.expiry_date, 'YYYYMMDDHHmmss')}
                                </TableCell>

                                <TableCell>{ele?.can_grindding}</TableCell>

                                <TableCell>{ele?.cabinet_cd}</TableCell>
                                <TableCell>{ele?.drawer_lc}</TableCell>
                                <TableCell>
                                    {ele?.cabinet_type === 'square'
                                        ? ele?.cell_lc
                                            ? `[ ${ele.cell_lc.row} : ${ele.cell_lc.column} ]`
                                            : ''
                                        : ele?.cell_lc?.column || ''}
                                </TableCell>
                                <TableCell>{ele?.qty}</TableCell>

                                {property?.map((p, idx) => {
                                    const match = ele?.properties_device?.find((d) => d.label === p.label);
                                    return (
                                        <TableCell key={idx} align="right">
                                            {match?.value ?? ''}
                                        </TableCell>
                                    );
                                })}
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default TableLocationDevice;
